<template>
  <main class="mdc-top-app-bar--fixed-adjust">
    <div class="d-flex flex-column h-full-56">
      <div class="pdb-18 flex-grow-1 bg-documentGray">
        <div class="pdl-16 pdr-16 pdt-16 pdb-24">
          <div class=" t-headline9 font-b t-line-h-36 l-spacing66">{{ $t('3391') }}</div>
          <div class="t-body3 l-spacing42 mgt-8 font-r t-color-bodyGrayA">{{ $t('3392') }}</div>
        </div>
        <div class="divider"></div>
        <div v-if="distributionDetail.length > 0" class="bg-documentGray pda-16">
          <div class="pdb-34">
            <div v-for="(myData, index) in distributionDetail" :key="index+myData.name" class="mdc-card mgb-16">
              <div class="d-flex align-items-center justify-content-between pdt-16 pdb-16 pdl-16 pdr-16">
                <div class="t-subtitle3 font-m flex-grow-1">{{ myData.name }}</div>
                <button class="mdc-icon-button content-trigger mgr--16 pdt-0 pdb-0 h-auto without-shadow">
                  <i class="material-icons t-headline12 t-color-bodyGrayA">{{
                      index == 0 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    }}</i>
                </button>
              </div>
              <div :class="index == 0 ?'' :'d-none'" class="detail-content">
                <div v-for="(innerData, indexInner) in myData.questions" :key="indexInner">
                  <div class="divider"></div>
                  <div class="qa-wrapper pdt-20 pdb-16 pdl-16 pdr-16">
                    <div class="q-wrapper">
                      <div class="d-flex">
                        <div class="t-subtitle2 font-b t-nowrap">Q{{ indexInner + 1 }}.</div>
                        <div class="flex-grow-1 pdl-4">
                          <span class="t-body1 font-r  l-spacing42">{{ innerData.question.contents }}</span>
                          <!-- 개별 점수 주석 처리 -->
                          <!-- <span
                              class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42 font-r">{{
                              $t('3380', {str: innerData.question.score})
                            }}</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'SHORT_ANSWER'" class="pdl-16 pdr-16 pdb-16">
                    <div class="preview_input t-body3 font-r">
                      {{ formDataAllStep[index][indexInner + 1].text }}
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'SHORT_ANSWER' && formDataAllStep[index][indexInner+1].comment"
                       class="pdt-4">
                    <div class="pda-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
                        </div>

                        <div class="preview_textArea t-body3 font-r mgt-24">
                          {{ formDataAllStep[index][indexInner + 1].comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 미디어 첨부파일을 보여주는 부분 -->
                  <div class="pdl-16 pdr-16 pdb-16">
                    <div
                    v-if="Array.isArray(formDataAllStep[index][indexInner+1].images) && formDataAllStep[index][indexInner+1].images.length > 0"
                    class="image-scroll-wrapper"
                  >
                    <div class="image-list-horizontal">
                      <div
                        class="image-item"
                        v-for="(img, imgIdx) in formDataAllStep[index][indexInner+1].images"
                        :key="imgIdx"
                      >
                        <img
                          v-if="getType(img.contentType) === 'image'"
                          :src="img.resourceUri"
                          alt=""
                          class="chcklist-ans-image"
                        />
                        <video-player
                          v-else
                          :image="img"
                          :imgHeight="104"
                          :imgWidth="104"
                        ></video-player>
                      </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'DATE'" class="pdl-16 pdr-16 pdb-16">

                    <div class="preview_input t-body3 font-r">
                      {{ formDataAllStep[index][indexInner + 1].text }}
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'DATE' 	&& formDataAllStep[index][indexInner+1].comment"
                       class="pdt-4">
                    <div class="pda-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
                        </div>

                        <div class="preview_textArea t-body3 font-r mgt-24">
                          {{ formDataAllStep[index][indexInner + 1].comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 미디어 첨부파일을 보여주는 부분 -->
                  <div v-if="innerData.question.type.value === 'DATE' && formDataAllStep[index][indexInner+1].image && formDataAllStep[index][indexInner+1].image.resourceUri"
                       class="">
                    <div class=" pdb-16 pdl-16 pdr-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3370') }}</div>
                        </div>

                        <div
                            class="d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive position-relative">
                          <img v-if="getType(formDataAllStep[index][indexInner+1].image.contentType) === 'image'"
                               :src="formDataAllStep[index][indexInner+1].image.resourceUri" alt=""
                               class="chcklist-ans-image">
                          <video-player v-else :image="formDataAllStep[index][indexInner+1].image" :imgHeight="104"
                                        :imgWidth="104"></video-player>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'NUMBER' || innerData.question.type.value === 'TEXT'"
                       class="pdl-16 pdr-16 pdb-16">
                    <div class="preview_input t-body3 font-r">
                      {{ formDataAllStep[index][indexInner + 1].text }}
                    </div>
                  </div>

                  <div v-if="(innerData.question.type.value === 'NUMBER' || innerData.question.type.value === 'TEXT') && formDataAllStep[index][indexInner+1].comment"
                       class="pdt-4">
                    <div class="pda-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
                        </div>


                        <div class="preview_textArea t-body3 font-r mgt-24">
                          {{ formDataAllStep[index][indexInner + 1].comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 미디어 첨부파일을 보여주는 부분 -->
                  <div v-if="(innerData.question.type.value === 'NUMBER' || innerData.question.type.value === 'TEXT') 	&& formDataAllStep[index][indexInner+1].image && formDataAllStep[index][indexInner+1].image.resourceUri"
                       class="">
                    <div class=" pdb-16 pdl-16 pdr-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3370') }}</div>
                        </div>

                        <div
                            class="d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive position-relative">
                          <img v-if="getType(formDataAllStep[index][indexInner+1].image.contentType) === 'image'"
                               :src="formDataAllStep[index][indexInner+1].image.resourceUri" alt=""
                               class="chcklist-ans-image">
                          <video-player v-else :image="formDataAllStep[index][indexInner+1].image" :imgHeight="104"
                                        :imgWidth="104"></video-player>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'CHOICE_WORKS'" class="pdl-16 pdr-16 pdb-16">
                    <div v-for="(choiceInner, innerIndex2) in innerData.question.worksChoice.choiceList"
                         :key="innerIndex2+choiceInner.id"
                         class="t-helper mgt-12">
                      <div class="mdc-form-field mdc-form-field--align-end">
                        <div class="mdc-checkbox custom_checkbox">
                          <!-- Updated By jungnam.lee@emcast.com Modify so that only 'works' checked by the user is checked-->
                          <input v-if="isWorksChecked(choiceInner.id, formDataAllStep[index][indexInner+1].works)"
                                 v-model="choiceInner.id"
                                 :value="choiceInner.id" class="mdc-checkbox__native-control" disabled
                                 type="checkbox">
                          <input v-else :value="choiceInner.id" class="mdc-checkbox__native-control" disabled
                                 type="checkbox">

                          <div class="mdc-checkbox__background check-red">
                            <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                              <path class="mdc-checkbox__checkmark-path" d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                    fill="none"></path>
                            </svg>
                            <div class="mdc-checkbox__mixedmark"></div>
                          </div>
                        </div>
                      </div>
                      <label class="t-body3 l-spacing42 font-r pdl-12" for="basic-checkbox t-button">
                        {{ choiceInner.name && choiceInner.name.fullName ? choiceInner.name.fullName : "" }}
                      </label>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'CHOICE_WORKS' && formDataAllStep[index][indexInner+1].comment"
                       class="pdt-4">
                    <div class="pda-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
                        </div>
                        <div class="preview_textArea t-body3 font-r mgt-24">
                          {{ formDataAllStep[index][indexInner + 1].comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 미디어 첨부파일을 보여주는 부분 -->
                  <div v-if="innerData.question.type.value === 'CHOICE_WORKS' && formDataAllStep[index][indexInner+1].image && formDataAllStep[index][indexInner+1].image.resourceUri"
                       class="">
                    <div class=" pdb-16 pdl-16 pdr-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3370') }}</div>
                        </div>

                        <div
                            class="d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive position-relative">
                          <img v-if="getType(formDataAllStep[index][indexInner+1].image.contentType) === 'image'"
                               :src="formDataAllStep[index][indexInner+1].image.resourceUri" alt=""
                               class="chcklist-ans-image">
                          <video-player v-else :image="formDataAllStep[index][indexInner+1].image" :imgHeight="104"
                                        :imgWidth="104"></video-player>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'CHOICE_SINGLE'" class="pdl-16 pdr-16 pdb-16">
                    <div v-for="(choiceInner, innerIndex2) in innerData.question.singleChoice.choiceList"
                         :key="innerIndex2+choiceInner.id"
                         class="t-helper">
                      <div class="mdc-form-field mgr-24 mgt-12">
                        <div class="mdc-radio">
                          <input :id="'radio-'+choiceInner.id" v-model="formDataAllStep[index][indexInner+1].selected[innerIndex2]" :name="'radio-'+choiceInner.id"
                                 :value="true" class="mdc-radio__native-control"
                                 disabled type="radio">
                          <div class="mdc-radio__background">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                          </div>
                          <div class="mdc-radio__ripple"></div>
                        </div>
                        <label :for="'radio-'+choiceInner.id"
                               class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{ choiceInner.contents }}
                               <!-- 개별 점수 주석 처리 -->
                          <!-- <span
                              class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42 font-r">{{
                              $t('3380', {str: choiceInner.score})
                            }}</span> -->
                        </label>
                      </div>
                    </div>
                  </div>
                  <div v-if="innerData.question.type.value === 'CHOICE_SINGLE' && formDataAllStep[index][indexInner+1].comment"
                       class="pdt-4">
                    <div class="pda-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3369') }}</div>
                        </div>
                        <div class="preview_textArea t-body3 font-r mgt-24">
                          {{ formDataAllStep[index][indexInner + 1].comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 미디어 첨부파일을 보여주는 부분 -->
                  <div v-if="innerData.question.type.value === 'CHOICE_SINGLE' && formDataAllStep[index][indexInner+1].image && formDataAllStep[index][indexInner+1].image.resourceUri"
                       class="">
                    <div class=" pdb-16 pdl-16 pdr-16">
                      <div class="bg-documentGray pdt-16 pdl-16 pdr-16 pdb-16 b-radius4">
                        <div class="d-flex justify-content-between align-items-center mgb-12">
                          <div class="t-body3 font-r l-spacing42">{{ $t('3370') }}</div>
                        </div>

                        <div
                            class="d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive position-relative">
                          <img v-if="getType(formDataAllStep[index][indexInner+1].image.contentType) === 'image'"
                               :src="formDataAllStep[index][indexInner+1].image.resourceUri" alt=""
                               class="chcklist-ans-image">
                          <video-player v-else :image="formDataAllStep[index][indexInner+1].image" :imgHeight="104"
                                        :imgWidth="104"></video-player>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4"
                  tabindex="0" @click="SubmittedData" @keypress="SubmittedData">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body3">{{ $t('3393') }}</span>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import checklistApi from '@/api/checklistApi.js'
import {fileMixin} from "@/mixins/file";

export default {
  props: ['formDataAllStep', 'distributionDetail', 'dataId'],

  components: {
    'video-player': () => import('@/components/common/VideoPlayer')
  },

  mixins: [fileMixin],

  data() {
    return {}
  },

  mounted() {
    if (document.querySelectorAll(".content-trigger")) {
      var contentTrigger = Array.from(document.querySelectorAll(".content-trigger"));
      contentTrigger.forEach((item) => {
        item.addEventListener("click", function () {
          if ((this.firstChild.innerHTML) === 'keyboard_arrow_down') {
            this.firstChild.innerHTML = 'keyboard_arrow_up'
          } else {
            this.firstChild.innerHTML = 'keyboard_arrow_down'
          }
          this.parentNode.nextElementSibling.classList.toggle("d-none")
        });
      })
    }
  },

  methods: {
    SubmittedData() {
      let submitAllQuestionData = {};
      for (let i = 0; i < this.distributionDetail.length; i++) {
        for (let j = 0; j < this.distributionDetail[i].questions.length; j++) {
          let id = this.distributionDetail[i].questions[j].question.id;
          submitAllQuestionData[id] = this.formDataAllStep[i][j + 1];
        }
      }
      this.submitAllStepResults(submitAllQuestionData, this.dataId);

    },
    submitAllStepResults(data, id) {
      this.$showLoading();
      checklistApi.submitCheckList(data, id).then((_response) => {
        this.$hideLoading();
        this.moveToAlert();
      }).catch((_err) => {
        this.$hideLoading();
      });
    },
    moveToAlert() {
      let newParams = {
        title: '',
        content: this.$t('3398'),
        accept: this.$t('3399'),
        cancel: ''
      }
      this.$alert(newParams).then((_res) => {
        this.$router.push({
          name: 'SubmittedResult',
          params: {postId: this.dataId},
          query: {checkId: this.$route.params.postId}
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    //Updated By jungnam.lee@emcast.com : Modify so that only 'works' checked by the user is checked
    isWorksChecked(worksValue, checks) {
      return checks.indexOf(worksValue) > -1
    }
  }
}
</script>

<style scoped>
.image-scroll-wrapper {
  overflow-x: auto;
}
.image-list-horizontal {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
.image-item {
  position: relative;
  flex: 0 0 104px;
  width: 104px;
  height: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chcklist-ans-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>
